export default __webpack_public_path__ + "static/media/est-time.64e6f185.png";